module.exports = __webpack_public_path__ + "static/media/Networth4.3f75f8aa.png";